import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Bands } from "../../Banding/Types";
import { OutputConfigSlice } from "../../redux";
import { SelectedReport } from "../ConfigDetailsForm/Types";
import { Actions } from "../OutputMappingButtonsBar/Types";
import { OutputMappingItem } from "../OutputMappingList/Types";
import { OUTPUT_CONFIG_MAP_HIGHLIGHT } from "../../Constant";
import { OutputMappingListCardView } from "./OutputMappingListCard.view";

interface OutputMappingListCardProps {
  /**
   * Mapped config api response
   */
  mappedConfig: OutputMappingItem;
  /**
   * Current mapped config index
   */
  currentMapIndex: number;
}

/**
 * Responsible for list card logic
 */
export const OutputMappingListCard: React.FC<OutputMappingListCardProps> = (props: OutputMappingListCardProps) => {
  const { mappedConfig, currentMapIndex } = props;
  const [selectedToggle, setSelectedToggle] = useState(Bands.AGE);
  const dispatch = useDispatch();

  /**
   * Action when Manage Bindings Dropdown value is selected
   */
  const onSelectBand = (band: string): void => {
    dispatch(OutputConfigSlice.actions.setSelectedOutputMapping(
      {
        status: true,
        action: Actions.CLOSE,
        band: band,
        configMapId: mappedConfig.configMapId,
        configTag: mappedConfig.tag
      }));
  };

  /**
   * Action when Edit Config detail button is clicked
   */
  const onEditConfigDetail = (): void => {
    const element = document.getElementById(mappedConfig.configMapId);
    if (element && element.classList.contains(OUTPUT_CONFIG_MAP_HIGHLIGHT)) {
      element.classList.remove(OUTPUT_CONFIG_MAP_HIGHLIGHT);
    }
    dispatch(OutputConfigSlice.actions.setSelectedOutputMapping(
      {
        status: true,
        action: Actions.MODIFY,
        band: Actions.EMPTY,
        configMapId: mappedConfig.configMapId
      }));

    dispatch(OutputConfigSlice.actions.setOutputMappingPopupEditConfigData({
      configMapId: mappedConfig.configMapId,
      configName: mappedConfig.configName,
      tag: mappedConfig.tag,
      sourceReport: mappedConfig.sourceReport as SelectedReport,
      includeInOutput: mappedConfig.includeInOutput
    }));
  };

  /**
   * Action on Toggle Button Select
   */
  const onToggleButtonSelect = (value: number): void => {
    setSelectedToggle(value);
  };

  /**
   * Action on pick report
   */
  const onPickReport = (): void => {
    return;
  };

  return (
    <OutputMappingListCardView
      mappedConfig={mappedConfig}
      onSelectBand={onSelectBand}
      onEditConfigDetail={onEditConfigDetail}
      onToggleButtonSelect={onToggleButtonSelect}
      selectedToggle={selectedToggle}
      onPickReport={onPickReport}
      currentMapIndex={currentMapIndex}
    />
  );
};
